module.exports = __webpack_public_path__ + "img/victrix-bretelle-9.d89c9d4c.jpg";